"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useInputBorderCss", {
    enumerable: true,
    get: function() {
        return useInputBorderCss;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _FormGroupContext = require("../../contexts/FormGroupContext");
const _FormInputGroupContext = require("./FormInputGroup/FormInputGroupContext");
const _Theme = require("../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const useInputBorderCss = function() {
    let { selector = "*", showBorder, showChrome, rounded: roundedInput } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { hasError } = _react.default.useContext(_FormGroupContext.FormGroupContext);
    const { colors, borderRadius, animationDuration, focusOutline } = (0, _Theme.useTheme)();
    const inputGroup = _react.default.useContext(_FormInputGroupContext.FormInputGroupContext);
    var _ref;
    const show = (_ref = showBorder !== null && showBorder !== void 0 ? showBorder : showChrome) !== null && _ref !== void 0 ? _ref : !inputGroup.inGroup;
    var _ref1;
    const rounded = (_ref1 = roundedInput !== null && roundedInput !== void 0 ? roundedInput : inputGroup.rounded) !== null && _ref1 !== void 0 ? _ref1 : "corners";
    const borderRadiusResolved = rounded === "corners" ? borderRadius : "100px";
    if (show === true) {
        return {
            styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
                id: "e006d4fc1462db21",
                dynamic: [
                    selector,
                    hasError ? colors.danger : colors.border,
                    borderRadiusResolved,
                    animationDuration,
                    selector,
                    selector,
                    hasError ? colors.danger : colors.inputBorder,
                    focusOutline.size,
                    hasError ? focusOutline.colors.error : focusOutline.colors.default
                ]
            }, "".concat(selector, ".__jsx-style-dynamic-selector{border:1px solid ").concat(hasError ? colors.danger : colors.border, "!important;-webkit-border-radius:").concat(borderRadiusResolved, "!important;-moz-border-radius:").concat(borderRadiusResolved, "!important;border-radius:").concat(borderRadiusResolved, "!important;-webkit-transition:").concat(animationDuration, " box-shadow,border;-moz-transition:").concat(animationDuration, " box-shadow,border;-o-transition:").concat(animationDuration, " box-shadow,border;transition:").concat(animationDuration, " box-shadow,border}").concat(selector, ".__jsx-style-dynamic-selector:focus,").concat(selector, ".focus-in.__jsx-style-dynamic-selector{border:1px solid ").concat(hasError ? colors.danger : colors.inputBorder, "!important;-webkit-box-shadow:0 0 0 ").concat(focusOutline.size, " ").concat(hasError ? focusOutline.colors.error : focusOutline.colors.default, "!important;-moz-box-shadow:0 0 0 ").concat(focusOutline.size, " ").concat(hasError ? focusOutline.colors.error : focusOutline.colors.default, "!important;box-shadow:0 0 0 ").concat(focusOutline.size, " ").concat(hasError ? focusOutline.colors.error : focusOutline.colors.default, "!important}")),
            className: _style.default.dynamic([
                [
                    "e006d4fc1462db21",
                    [
                        selector,
                        hasError ? colors.danger : colors.border,
                        borderRadiusResolved,
                        animationDuration,
                        selector,
                        selector,
                        hasError ? colors.danger : colors.inputBorder,
                        focusOutline.size,
                        hasError ? focusOutline.colors.error : focusOutline.colors.default
                    ]
                ]
            ])
        };
    }
    if (show === "onInteraction") {
        return {
            styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
                id: "5e07d19293c2b8f8",
                dynamic: [
                    selector,
                    hasError ? colors.danger : "transparent",
                    borderRadiusResolved,
                    animationDuration,
                    selector,
                    hasError ? colors.danger : colors.border,
                    colors.white,
                    selector,
                    selector,
                    hasError ? colors.danger : colors.inputBorder,
                    colors.white,
                    focusOutline.size,
                    hasError ? focusOutline.colors.error : focusOutline.colors.default
                ]
            }, "".concat(selector, ".__jsx-style-dynamic-selector{border:1px solid ").concat(hasError ? colors.danger : "transparent", "!important;-webkit-border-radius:").concat(borderRadiusResolved, "!important;-moz-border-radius:").concat(borderRadiusResolved, "!important;border-radius:").concat(borderRadiusResolved, "!important;-webkit-transition:").concat(animationDuration, " box-shadow,border;-moz-transition:").concat(animationDuration, " box-shadow,border;-o-transition:").concat(animationDuration, " box-shadow,border;transition:").concat(animationDuration, " box-shadow,border}").concat(selector, ".__jsx-style-dynamic-selector:hover{border:1px solid ").concat(hasError ? colors.danger : colors.border, "!important;background-color:").concat(colors.white, "!important}").concat(selector, ".__jsx-style-dynamic-selector:focus,").concat(selector, ".focus-in.__jsx-style-dynamic-selector{border:1px solid ").concat(hasError ? colors.danger : colors.inputBorder, "!important;background-color:").concat(colors.white, "!important;-webkit-box-shadow:0 0 0 ").concat(focusOutline.size, " ").concat(hasError ? focusOutline.colors.error : focusOutline.colors.default, "!important;-moz-box-shadow:0 0 0 ").concat(focusOutline.size, " ").concat(hasError ? focusOutline.colors.error : focusOutline.colors.default, "!important;box-shadow:0 0 0 ").concat(focusOutline.size, " ").concat(hasError ? focusOutline.colors.error : focusOutline.colors.default, "!important}")),
            className: _style.default.dynamic([
                [
                    "5e07d19293c2b8f8",
                    [
                        selector,
                        hasError ? colors.danger : "transparent",
                        borderRadiusResolved,
                        animationDuration,
                        selector,
                        hasError ? colors.danger : colors.border,
                        colors.white,
                        selector,
                        selector,
                        hasError ? colors.danger : colors.inputBorder,
                        colors.white,
                        focusOutline.size,
                        hasError ? focusOutline.colors.error : focusOutline.colors.default
                    ]
                ]
            ])
        };
    }
    return {
        styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "c979b71332b04de",
            dynamic: [
                selector,
                borderRadiusResolved
            ]
        }, "".concat(selector, ".__jsx-style-dynamic-selector{border:none;-webkit-border-radius:").concat(borderRadiusResolved, "!important;-moz-border-radius:").concat(borderRadiusResolved, "!important;border-radius:").concat(borderRadiusResolved, "!important}")),
        className: _style.default.dynamic([
            [
                "c979b71332b04de",
                [
                    selector,
                    borderRadiusResolved
                ]
            ]
        ])
    };
};

//# sourceMappingURL=useInputBorderCss.js.map